import React from "react";
import ReactTable from "react-table";
import { Link } from "react-router-dom";
import { convertBooleanToTag } from "../../helpers";
import { Select, Button, Icon } from "antd";

const { Option } = Select;
var dateFormat = require("dateformat");

class Table extends React.Component {
  render() {
    return (
      <div className="table-container ">
        <div style={{ margin: "10px", textAlign: "right" }}>
          <Link to={"/portal/home-page-versions/create"}>
            <Button
              ghost
              icon="file-add"
              type="primary"
              style={{ marginRight: "5px" }}
            >
              Create Landing Page
            </Button>
          </Link>
        </div>
        <ReactTable
          data={this.props.homePageVersions}
          noDataText="No Landing Page Versions Found"
          filterable
          columns={[
            {
              Header: "Version ID",
              id: "version_id",
              width: 120,
              accessor: d => d.version_id,
              Cell: row => (
                <Link to={"/portal/home-page-versions/" + row.value}>
                  {row.value}
                </Link>
              )
            },
            {
              Header: "Default",
              id: "default",
              width: 100,
              accessor: d => d.default,
              Cell: row => convertBooleanToTag(row.value),
              filterMethod: (filter, row) => {
                if (filter.value === "all") {
                  return true;
                }
                if (filter.value === "true") {
                  return row["default"] === true;
                }
                return row["default"] === false;
              },
              Filter: ({ filter, onChange }) => (
                <Select
                  size="small"
                  value={filter ? filter.value : "all"}
                  style={{ width: "100%" }}
                  onChange={onChange}
                >
                  <Option value="all">Show All</Option>
                  <Option value="true">True</Option>
                  <Option value="false">False</Option>
                </Select>
              )
            },
            {
              Header: "Active",
              id: "active",
              width: 100,
              accessor: d => d.active,
              Cell: row => convertBooleanToTag(row.value),
              filterMethod: (filter, row) => {
                if (filter.value === "all") {
                  return true;
                }
                if (filter.value === "true") {
                  return row["active"] === true;
                }
                return row["active"] === false;
              },
              Filter: ({ filter, onChange }) => (
                <Select
                  size="small"
                  value={filter ? filter.value : "all"}
                  style={{ width: "100%" }}
                  onChange={onChange}
                >
                  <Option value="all">Show All</Option>
                  <Option value="true">True</Option>
                  <Option value="false">False</Option>
                </Select>
              )
            },
            {
              Header: "Promotion",
              id: "promotion",
              width: 120,
              accessor: d => d,
              Cell: row => (
                <Link to={"/portal/promotions/" + row.value.promotion}>
                  {row.value.promotion_internal_name}
                </Link>
              )
            },
            {
              Header: "Internal Title",
              id: "internal_title",
              accessor: d => d.internal_title
            },
            {
              Header: "Header",
              id: "header",
              accessor: d => d.header
            },
            {
              Header: "Subheader",
              id: "subheader",
              accessor: d => d.subheader
            },
            {
              Header: "CTA",
              id: "call_to_action",
              accessor: d => d.call_to_action
            },
            {
              Header: "Version URL",
              id: "version_url",
              width: 120,
              accessor: d => d.version_url,
              Cell: row => (
                <a href={row.value} target="_blank" rel="noopener noreferrer">
                  Go To Page <Icon type="link" />
                </a>
              )
            },
            {
              Header: "Date Created",
              id: "date_created",
              accessor: d => d.date_created,
              Cell: row => dateFormat(row.value, " mmmm dS yyyy"),
              sortMethod: (a, b) => {
                var d1 = new Date(a);
                var d2 = new Date(b);
                return d1 > d2 ? 1 : -1;
              }
            }
          ]}
          className="-striped -highlight"
        />
      </div>
    );
  }
}

export default Table;
